import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import {postponeSsoDraftFinalization} from 'src/openapi/admin/apis/SsoV2Api';
import {useAppDispatch} from 'src/store/hooks';

import {Button} from '@pb/kit-component-button';
import {Dialog, DialogFooter} from '@pb/kit-component-dialog-v2';
import Loading from '@pb/kit-component-loading';

import type {Result} from 'src/modules/draft-postpone/typedef';
import type {Error} from 'src/openapi/admin/models/Error';

export const DraftPostponeHandler: React.FC = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const dispatch = useAppDispatch();
    const [result, setResult] = useState<Result | null>(null);

    useEffect(() => {
        if (!token) {
            setResult({success: false, message: 'Invalid or missing token.'});
            return;
        }

        const postpone = async () => {
            const response = await dispatch(postponeSsoDraftFinalization(
                {draftPostponeRequest: {token}}));

            if (response.payload.success) {
                setResult({success: true, message: 'Draft finalization has been successfully postponed.'});
            } else {
                const error = response.payload.data as Error;
                const messages = error?.detailMessages
                    ?? ['An unexpected error occurred. Please try again or contact support.'];

                setResult({success: false, message: messages.join(' ')});
            }
        };

        postpone();
    }, [token, dispatch]);

    const handleClose = () => {
        window.location.href = window.location.origin;
    };

    if (!result) {
        return <Loading fast={true}/>;
    }

    return (
        <Dialog
            shown={true}
            setShown={handleClose}
            dismissProps={{outsidePress: false, escapeKey: false}}
            wrapperProps={{style: {width: 480}}}>
            <div style={{padding: '16px 24px'}}>
                {result.message}
            </div>
            <DialogFooter>
                <Button variant="Type.PRIMARY" onClick={handleClose}>Close</Button>
            </DialogFooter>
        </Dialog>
    );
};
